import { Outlet } from "react-router-dom";


function PageUserDeckLayout() {
  return (
    <Outlet></Outlet>
  );
}

export default PageUserDeckLayout;